/* RYŌHŌ — Nettoyage des lignes cadeau héritées
 * Ce script n'ajoute plus rien au panier. La mécanique de cadeau automatique a été retirée
 * le 2026-08-23, en même temps que la réduction qui rendait la ligne gratuite.
 *
 * Rôle restant, et unique : les paniers construits AVANT ce retrait peuvent encore contenir
 * une ligne que l'ancienne mécanique avait ajoutée d'elle-même. Cette ligne n'étant plus
 * remise à 0, elle serait facturée plein tarif à une cliente qui ne l'a jamais choisie.
 * Ce script la retire.
 *
 * La ligne est reconnue à la propriété cachée `_ry_gift`, posée côté serveur au moment de
 * l'ajout automatique. C'est un marqueur fiable : une ligne ajoutée manuellement par la
 * cliente ne le porte pas et forme de toute façon une ligne distincte — elle ne peut donc
 * jamais être retirée par erreur.
 *
 * Aucune requête d'écriture n'est émise si le panier est propre (le cas courant) : on lit
 * /cart.js, et on ne touche à /cart/change.js que s'il y a effectivement une ligne à retirer.
 */
(function () {
  'use strict';

  var MAX_PASSES = 5; // borne dure : jamais de boucle de nettoyage infinie
  var busy = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Ligne héritée = toute ligne portant notre marqueur d'ajout automatique.
  function findLegacyGift(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].properties && items[i].properties._ry_gift) return items[i];
    }
    return null;
  }

  function removeLine(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  function announce(cart) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ryoho-auto-gift', cartData: cart });
      }
    } catch (e) {}
    return cart;
  }

  function sweep(cart, pass) {
    var line = findLegacyGift(cart);
    if (!line || pass >= MAX_PASSES) return Promise.resolve(cart);
    return removeLine(line).then(function (next) { return sweep(next, pass + 1); });
  }

  function run() {
    if (busy) return;
    busy = true;
    getCart()
      .then(function (cart) {
        if (!findLegacyGift(cart)) return null; // panier propre -> aucune écriture
        return sweep(cart, 0).then(announce);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function boot() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, run);
    }
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
